import {useDispatch as useReduxDispatch} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import isFunction from 'lodash/isFunction';

// Also give the location and navigate (react-router-dom v6) to dispatch action
const useDispatch = () => {
  const reduxDispatch = useReduxDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  return (action) => {
    if (isFunction(action)) return reduxDispatch(action)
    return reduxDispatch({ location, navigate, ...action })
  }
}

export default useDispatch;
